import { useQuery } from 'react-query';

import Api from '../api';
import { AuthStatus, useAuth } from '../context/auth';
import { queryClient } from './index';

const QueryKey = {
  UserSeniority: ['user-seniority'],
};

/**
 * Hook to fetch user seniority
 */
export const useUserSeniority = () => {
  const { status } = useAuth();

  return useQuery(QueryKey.UserSeniority, Api.getCurrentUserSeniority, {
    enabled: status === AuthStatus.AUTHENTICATED,
    staleTime: Infinity,
  });
};

export const invalidateAndRemoveSeniorityCache = () => {
  queryClient.removeQueries(QueryKey.UserSeniority);
  return queryClient.invalidateQueries(QueryKey.UserSeniority);
};
